/**
 * QuickActionsPanel Component
 * Expandable panel with quick action buttons
 */

import React from "react";
import { Box, Typography, Button, IconButton, Collapse, useTheme, alpha } from "@mui/material";
import { useTranslation } from "react-i18next";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

const QuickActionsPanel = ({ questions, onQuestionClick, disabled, isExpanded, onToggle }) => {
        const { t } = useTranslation();
        const theme = useTheme();

        if (!questions || questions.length === 0) {
                return null;
        }

        return (
                <Box
                        sx={{
                                p: 1.5,
                                borderRadius: 2,
                                border: `1px solid ${alpha(theme.palette.divider, 0.3)}`,
                                backgroundColor: alpha(theme.palette.background.paper, 0.6),
                        }}
                >
                        <Box
                                sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        cursor: "pointer",
                                        "&:hover": {
                                                backgroundColor: alpha(theme.palette.action.hover, 0.05),
                                        },
                                }}
                                onClick={onToggle}
                        >
                                <Box>
                                        <Typography variant="subtitle2" fontWeight={600}>
                                                {t("ai-chat-tools-quick-actions")}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                                {t("ai-chat-tools-quick-actions-description")}
                                        </Typography>
                                </Box>
                                <IconButton
                                        size="small"
                                        onClick={(e) => {
                                                e.stopPropagation();
                                                onToggle();
                                        }}
                                >
                                        {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                </IconButton>
                        </Box>
                        <Collapse in={isExpanded}>
                                <Box
                                        sx={{
                                                display: "flex",
                                                flexWrap: "wrap",
                                                gap: 1,
                                                mt: 1.5,
                                        }}
                                >
                                        {questions.map((questionKey) => (
                                                <Button
                                                        key={questionKey}
                                                        variant="outlined"
                                                        size="small"
                                                        onClick={() => onQuestionClick(questionKey)}
                                                        disabled={disabled}
                                                        sx={{
                                                                borderRadius: "12px",
                                                                textTransform: "none",
                                                                fontWeight: 600,
                                                                minWidth: 0,
                                                                transition: "all 0.2s ease",
                                                                border: `1px solid ${alpha(theme.palette.divider, 0.3)}`,
                                                                background: alpha(theme.palette.background.paper, 0.5),
                                                                backdropFilter: "blur(10px)",
                                                                "&:hover": {
                                                                        border: `1px solid ${alpha(theme.palette.primary.main, 0.5)}`,
                                                                        background: alpha(theme.palette.primary.main, 0.05),
                                                                        transform: "translateY(-1px)",
                                                                },
                                                                "&:disabled": {
                                                                        opacity: 0.5,
                                                                },
                                                        }}
                                                >
                                                        {t(questionKey)}
                                                </Button>
                                        ))}
                                </Box>
                        </Collapse>
                </Box>
        );
};

export default QuickActionsPanel;

